export type LibraryScope = 'personal' | 'shared';

export function LibraryScopeSwitch({ value, onChange }: { value: LibraryScope; onChange: (value: LibraryScope) => void }) {
  return <div className="library-scope-switch" aria-label="Раздел библиотеки">
    <button type="button" aria-pressed={value === 'personal'} className={value === 'personal' ? 'active' : ''} onClick={() => onChange('personal')}>Личная</button>
    <button type="button" aria-pressed={value === 'shared'} className={value === 'shared' ? 'active' : ''} onClick={() => onChange('shared')}>Общая</button>
  </div>;
}
